import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioButtonGroup as RadioButton } from '@vds/radio-buttons';

class VdsRadioButton extends Component {
  render() {
    const { children, data, defaultValue, onChange, selected, fiosInService, multiService, value, parserView } = this.props;
    const props = { ...this.props };
    return (
      <span className={fiosInService || multiService ? 'vz5gh-radio-inservice' : 'vz5gh-radio-button'}>
        <RadioButton {...props}  value={parserView ? (value ? value : '') : defaultValue} defaultValue={defaultValue} data={data} onChange={onChange} selected={selected}>
          {children}
        </RadioButton>
      </span>
    );
  }
}

VdsRadioButton.defaultProps = {
  error: false,
  onChange: () => {},
};

VdsRadioButton.propTypes = {
  defaultValue: PropTypes.any,
  error: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.array,
  children: PropTypes.any,
  checked: PropTypes.any,
  fiosInService: PropTypes.bool,
  multiService: PropTypes.bool,
  selected: PropTypes.bool,
};

export default VdsRadioButton;
